
<div class="mat-elevation-z8">
  <div class="title">
    <p>Tab Manager</p>
  </div>
  <button mat-button (click)="onAddTab()" [disabled]="!selected">New Tab</button>
  <mat-form-field>
    <mat-label>Defaults</mat-label>
    <mat-select [(ngModel)]="selected">
      <mat-option *ngFor="let d of Defaults;" [value]="d">{{d}}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-accordion>
    <ng-container *ngFor="let tab of Tabs; index as i">
      <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{tab.get('UserID').value}} - 
              {{tab.get('Title').value}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-tab [Tab]="tab" [Email]="Email"></app-tab>
          <mat-action-row>
            <button mat-button (click)="onDeleteTab(i)">Delete</button>
            <button mat-button (click)="onSaveTab(i)" [disabled]="!tab.dirty||!tab.valid">Save</button>
          </mat-action-row>
      </mat-expansion-panel>
    </ng-container>
  </mat-accordion>
</div>

